import http from '@/services/http'
import { commonUrl } from '@/services/url'
import type { IUpdateNotifySettingParams } from '@/store/notifySettingSlice/type'
import type * as Types from './type'
import { businessTimezoneTranslate } from '../businessTimezone'
import type { ITaskListResponse } from '@/store/taskSlice/type'

interface ISellerSettingParam {
  settingCodes: string[]
}

/** 导入模板地址和更新时间 */
export const getTemplateInfo = async (data) => await http.admin.post(commonUrl.templateInfo, data)
/** 文本翻译 */
export const getTranslation = (data: Types.TranslateReq) => http.admin.post<Types.TranslateRes>('/api/commons/translate', data)
/** 获取商家授权仓库下所有物流渠道 */
export const getI18nLogisticsInfo = async (data: Types.II18nLogisticsParams) => http.admin.post<Types.LogisticsItem[]>('/api/logistics/list-logistics', data)
/** 获取商家授权仓库下的退货物流渠道 */
export const getI18nRefundLogisticsInfo = async (data: Types.II18nLogisticsParams) => http.admin.post<Types.LogisticsItem[]>('/api/logistics/list-refund-logistics', data)
/** 获取商家授权仓库下所有物流服务商 */
export const getAllLogisticsProviders = () => http.admin.post<Types.LogisticsProviderDTO[]>('/api/logistics/list-logistics-provider')

interface SalesPlatformListReqDTO {
  /**语言 */
  language?: string
  /**是否已串接，为空返回全部 */
  dock?: boolean
}
interface SalesPlatformDTO {
  code: string
  name: string
  label: string
}
/**
 * 获取所有销售平台列表
 * TODO: data不需要必填
 * @param data
 * @returns
 */
export const getSalesPlatform = async (data?: SalesPlatformListReqDTO) => await http.admin.post<SalesPlatformDTO[]>('/api/sales/sales_platform/list', data)
//获取最新需要弹框的公告栏
export const getPop = businessTimezoneTranslate(async (data) => await http.admin.post('/api/notify/get-pop', data), [], ['data.notifyDetail.onlineTime'])
//查询公告列表
export const notifyList = businessTimezoneTranslate(async (data) => await http.admin.post('/api/notify/list', data), [], ['data.list.[].notifyDetail.onlineTime'])
//已读公告栏
export const notifyRead = async (data) => await http.admin.post(commonUrl.notifyRead, data)
//未读公告栏
export const notifyCount = async (data) => await http.admin.post(commonUrl.notifyCount, data)
//站内信列表
export const messageList = businessTimezoneTranslate(
  async (data: Types.MessageListReq) => http.admin.post<Types.MessageListRes>('/api/message/list', data),
  [],
  ['data.list.[].createTime']
)
export const getTaskList = businessTimezoneTranslate(async (params: any) => http.admin.get<ITaskListResponse>('/api/tasks/list', { params }), [], ['data.list.[].createTime'])

//站内信已读接口
export const messageRead = async (data) => await http.admin.post(commonUrl.messageRead, data)
//未读站内信总数
export const messageCount = async (data) => await http.admin.post(commonUrl.messageCount, data)
/** 更新商家配置 */
export const updateSellerSetting = async (data) => await http.admin.post(commonUrl.updateSellerSetting, data)
/** 获取商家配置信息：地址算法匹配、币种转换设置等 */
export const getSellerSettings = (data: ISellerSettingParam) => http.admin.post<Types.GetSellerSettingRes>(commonUrl.getSellerSettings, data)
/** 获取dash开关配置（查询系统配置） */
export const getDashSettings = (data?) => http.admin.post<Types.GetSystemSettingRes>(commonUrl.getDashSettings, data)
/** 获取仓储商家基本信息，如：sellerId，warehouseSellerNo，sellerOwnerType */
export const getSellerBasicInfo = () => http.admin.post<Types.GetBasicInfoRes>('/api/seller/get-basic-info')

/** update email setting */
export const updateEmailSetting = (params: IUpdateNotifySettingParams) => http.admin.post('/api/settings/updateNotifySetting', params)

export const updateEmailList = (
  mails: Array<{
    email: string
    enable: boolean
  }>
) => http.admin.post('/api/settings/updateNotificationMails', { mails })

interface CustomLogisticsDTO {
  carrierCode?: string
  carrierName?: string
  carrierNames?: Record<string, string>
}
/**
 * **接口** [获取自定义物流运输商列表↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F202400402_3743_outboundorder_support_upload_waybill/interface/5de0b5eaf34b2bc56bb6971f9f35ba38)
 * @请求头 `POST /api/logistics/list-custom-logistics`
 * @更新时间 `2024-03-06 15:03:14`
 */
export function postListCustomLogistics(data: { logisticsId: string }) {
  return http.admin.post<CustomLogisticsDTO[]>(`/api/logistics/list-custom-logistics`, data)
}

export function getTimezoneList() {
  return http.admin.get<{ timeZomeItems: { displayName: string; gmtOffset: string; key: string }[] }>('/api/settings/time-zone/list')
}

export interface RiskResultBo {
  eventCode?: string
  source?: string
  countryCode?: string
  serialNo?: string
  hitPunishType?: string
  hitPunish?: string
  hitRiskTypes?: string[]
  hitBusinessTags?: string[]
}
export interface UserExportFileResponse {
  url?: string
  riskResult?: RiskResultBo
}

export function file(data: { batchTaskId: string }, headers: Record<string, any>) {
  return http.admin.post<UserExportFileResponse>(`/api/tasks/file`, data, { ...headers })
}
